import loadingGif from "../images/iQ-AnnimatedLogo-CrafterofCute.gif";

function Spinner({ compact = false, size = 100 }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: compact ? "0" : "24px 0",
      }}
    >
      <img src={loadingGif} alt="Loading..." width={size} />
    </div>
  );
}

export default Spinner;
